export default "__VITE_ASSET__DVCKt4G1__"